import { createFileRoute } from "@tanstack/react-router";

import { AppLayout } from "@/presentation/layouts/AppLayout";
import { MatrixPage } from "@/presentation/pages/MatrixPage";

export const Route = createFileRoute("/risk-matrix")({
  component: function MatrixComponent() {
    return (
      <AppLayout>
        <MatrixPage />
      </AppLayout>
    );
  },
});
